import { useSelector } from 'react-redux';
import { organisationSlug as primaryOrgSlug } from 'settings';
import { selectOrganisationSlug } from '@organisation/redux/selectors';

export default () => {
  const orgSlug = useSelector(selectOrganisationSlug());
  return orgSlug === primaryOrgSlug;
};
